import { Injectable } from '@angular/core';

import { isLancamentoAutomatico } from '../../atividade-lancamento';

/** Service que valida o acessos as telas dos status das Cotações */
@Injectable({
    providedIn: 'root'
})
export class AtividadeChecklistItemAuthGuardService {

    /** Verifica se pode editar o item do checklist da atividade */
    canEdit(lancamento: number): boolean {
        // Se for um lançamento automático não pode editar
        return !isLancamentoAutomatico(lancamento);
    }

    /** Verifica se pode inserir itens no checklist da atividade */
    canInsert(canInsertManual: boolean): boolean {
        // Se não puder inserir manualmente um item no checklist
        if (!canInsertManual) {
            return false;
        }

        return true;
    }

    /** Verifica se pode excluir o item do checklist da atividade */
    canDelete(lancamento: number): boolean {
        // Se for um lançamento automático não pode excluir
        return !isLancamentoAutomatico(lancamento);
    }
}
